import { render, staticRenderFns } from "./MultiFacetChart.vue?vue&type=template&id=dc2a477e&"
import script from "./MultiFacetChart.vue?vue&type=script&lang=js&"
export * from "./MultiFacetChart.vue?vue&type=script&lang=js&"
import style0 from "./MultiFacetChart.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports